// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__Jbc7h","title":"Settings_title__7MmHZ","pageTitle":"Settings_pageTitle__BxRn0","grid":"Settings_grid__oAl7K"};